import { styled, InputLabel as MuiInputLabel } from '@mui/material';
export var StyledInputLabel = styled(MuiInputLabel)({});
//# sourceMappingURL=styled.js.map